import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postSpecialite } from "./ServiceSpecialite";
import { useTranslation } from "react-i18next";
export default function AddSpecialite() {

  const navigate = useNavigate();

  const [data, setData] = useState({
    specialite: "",
    specialiteArab: "",
    specialiteAng: "",
  });
 const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState({});

  // Gestion des champs
  const onInputchange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  // Enregistrement
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await postSpecialite(data);

      toast.success( t("specialite.saveSuccess"), {
        position: "bottom-right",
        autoClose: 2000,
      });

      setData({
        specialite: "",
        specialiteArab: "",
        specialiteAng: "",
      });

      setErrorMessage({});

      navigate("/listspecialite");

    } catch (error) {
      //console.log("ERREUR COMPLETE");
      //console.log(error.response);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {

        const errorArray = error.response.data.errors;

        // Construction du toast
        const formattedErrors = errorArray.map((err, index) => {

          const msg =
            err.indexOf(":") > -1
              ? err.split(":")[1]
              : err;

          return (
            <li key={index} className="list-group-item">
              {msg}
            </li>
          );
        });

        toast.error(
          <div style={{ width: "18rem" }}>
            <div className="card-header text-danger">
              <h5 className="card-title">
                {t("common.validationErrors")}
              </h5>
            </div>

            <div className="card-body">
              <ul className="list-group list-group-flush">
                {formattedErrors}
              </ul>
            </div>
          </div>,
          {
            position: "bottom-right",
            autoClose: 4000,
          }
        );

        const errorObject = {};

        errorArray.forEach((err) => {

          if (err.indexOf(":") > -1) {

            const [field, message] = err.split(":");

            errorObject[field.trim()] = message.trim();
          }
        });

        setErrorMessage(errorObject);

      } else {

        toast.error("Erreur lors de l'enregistrement");

        console.error(error);
      }
    }
  };

  return (
    <div
      className="div-width"
      style={{ marginTop: "6rem" }}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-5">

          <li className="breadcrumb-item">
            <i className="fa-solid fa-house"></i>

            <Link
              className="mx-2"
              to="/"
            >
               {t("menu.home")}
            </Link>
          </li>

          <li className="breadcrumb-item">
            <Link
              className="mx-2"
              to="/Listspecialite"
            >
              {t("specialite.titre")}
            </Link>
          </li>

          <li className="breadcrumb-item active">
             {t("specialite.new")}
          </li>

        </ol>
      </nav>

      <div className="table-container">

        <div className="title div-responsive d-flex text-white justify-content-center align-items-center">
          <i className="fa-solid fa-folder-plus fa-2xl"></i>
        </div>

        <div className="border shadow rounded-2 p-3">

          <h4 className="ajst-titre mb-4">
             {t("specialite.new")}
          </h4>
          <form onSubmit={onSubmit}>
            <div className="row justify-content-center">
              <div className="col-md-6">
                {/* natureActivityType */}
                <div className="mb-3">
                  <label className="form-label required-label">
                    {t("monProfile.activityType")}
                  </label>
                  <select
                    className="form-select"
                    name="natureActivityType"
                    value={data.natureActivityType ?? ""}
                    onChange={onInputchange}
                  >
                    <option value="">{t("common.select")}</option>
                    <option value="C">{t("consultant.types.agriculture")} </option>
                    <option value="L">{t("consultant.types.livestock")} </option>
                  </select>

                  {errorMessage.natureActivityType && (
                    <div className="text-danger mt-1">
                      {errorMessage.natureActivityType}
                    </div>
                  )}

                </div>

                {/* Activité FR */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.french")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="specialite"
                    value={data.specialite}
                    onChange={onInputchange}
                  />

                  {errorMessage.specialite && (
                    <div className="text-danger mt-1">
                      {errorMessage.specialite}
                    </div>
                  )}

                </div>

                {/* Activité {t("common.arabic")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.arabic")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="specialiteArab"
                    value={data.specialiteArab}
                    onChange={onInputchange}
                    dir="rtl"
                  />

                  {errorMessage.specialiteArab && (
                    <div className="text-danger mt-1">
                      {errorMessage.specialiteArab}
                    </div>
                  )}

                </div>

                {/* Activité {t("common.english")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.english")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="specialiteAng"
                    value={data.specialiteAng}
                    onChange={onInputchange}
                  />

                  {errorMessage.specialiteAng && (
                    <div className="text-danger mt-1">
                      {errorMessage.specialiteAng}
                    </div>
                  )}

                </div>

              </div>

            </div>

            <div className="text-center mt-4">

              <button
                type="submit"
                className="btn btn-outline-primary"
              >
                {t("button.save")}
              </button>

              <Link
                to="/Listspecialite"
                className="btn btn-outline-success mx-2"
              >
                {t("button.close")}
              </Link>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}